import { render, staticRenderFns } from "./UpdatePicPhone.vue?vue&type=template&id=22e1eebd&scoped=true"
import script from "./UpdatePicPhone.vue?vue&type=script&lang=js"
export * from "./UpdatePicPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1eebd",
  null
  
)

export default component.exports